module.exports = __webpack_public_path__ + "img/moneytool.a3cd87f2.jpeg";